import React from 'react';
import gsap from 'gsap/all';
import { AnimationElementPosition, AnimationPositionElement } from '../animations/AnimationCommon';
import styled from 'styled-components';
import Functions from '@client/style/Functions';
import { Breakpoints } from '@client/style/Variables';
import Lamps1 from '@client/assets/svgs/animations/lamps-1.svg';
import Lamps2 from '@client/assets/svgs/animations/lamps-2.svg';
import Lamps3 from '@client/assets/svgs/animations/lamps-3.svg';
import Lamps4 from '@client/assets/svgs/animations/lamps-4.svg';
import Lamps5 from '@client/assets/svgs/animations/lamps-5.svg';
import Lamps6 from '@client/assets/svgs/animations/lamps-6.svg';
import Lamps7 from '@client/assets/svgs/animations/lamps-7.svg';

const lampColors = ['#84AEFF', '#92CDDC', '#FFAD98', '#FFAE02', '#FFD9D0', '#FFDF9A', '#F74D38'];
let lampColorCounter = 1;

const StyledLampsContainer = styled.div`
	width: 40vw;
	${Functions.breakpoint(Breakpoints.mobile)} {
		width: 30vw;
	}
	${Functions.breakpoint(Breakpoints.desktop)} {
		width: 500px;
	}
	svg {
		width: 100%;
		height: auto;
	}
`;

export const AnimationElementLamps = (props: {
	variant?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
	position: AnimationElementPosition;
}) => {
	const ref = React.useRef<HTMLDivElement>(null);
	const Variant = [Lamps1, Lamps2, Lamps3, Lamps4, Lamps5, Lamps6, Lamps7][props.variant ? props.variant - 1 : 0];
	// const parentTimeline = useAnimationContainerTimeline();

	React.useEffect(() => {
		const query = gsap.utils.selector(ref);

		const tween = gsap.to(query('.lamp'), {
			fill: () => lampColors[lampColorCounter++ % lampColors.length],
			transformOrigin: 'center center',
			keyframes: {
				scale: [1, 1.1, 1],
			},
			duration: 0.3,
			repeatDelay: 1,
			stagger: 0.2,
			repeatRefresh: true,
			ease: 'power1.inOut',
			repeat: -1,
			onRepeat: () => {
				tween.repeatDelay(gsap.utils.random(0.5, 1, 0.1));
			},
		});

		return () => {
			tween.kill();
		};
	}, []);

	return (
		<AnimationPositionElement ref={ref} position={{ ...props.position }}>
			<StyledLampsContainer>
				<Variant />
			</StyledLampsContainer>
		</AnimationPositionElement>
	);
};
